(function () {
  var root = document.querySelector('[data-varenzo-pdp]');
  if (!root) return;
  var lb = root.querySelector('[data-lightbox]');
  var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-zoom-index]'));
  if (!lb || !triggers.length) return;

  var img = lb.querySelector('[data-lb-img]');
  var stage = lb.querySelector('[data-lb-stage]');
  var count = lb.querySelector('[data-lb-count]');
  var zoomBtn = lb.querySelector('[data-lb-zoom]');
  var closeBtn = lb.querySelector('[data-lb-close]');
  var prevBtn = lb.querySelector('[data-lb-prev]');
  var nextBtn = lb.querySelector('[data-lb-next]');
  var live = lb.querySelector('[data-lb-live]');
  var idx = 0, lastFocus = null;
  var FOCUSABLE = 'button:not([disabled]),[tabindex]:not([tabindex="-1"])';

  if (triggers.length < 2) { prevBtn.hidden = true; nextBtn.hidden = true; }

  function inertOthers(on) {
    var header = document.getElementById('header-group');
    var footer = document.querySelector('.page-wrapper > footer');
    var shell = root.querySelector('.v-pdp-shell');
    [shell, header, footer].forEach(function (el) {
      if (!el) return;
      if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  }

  function setZoom(on) {
    lb.classList.toggle('zoomed', on);
    zoomBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    zoomBtn.textContent = on ? 'Zoom out' : 'Zoom in';
    stage.setAttribute('aria-label', on ? 'Zoomed image. Use the arrow keys to pan.' : 'Enlarged image');
    if (on) {
      requestAnimationFrame(function () {
        stage.scrollLeft = Math.max(0, (stage.scrollWidth - stage.clientWidth) / 2);
        stage.scrollTop = Math.max(0, (stage.scrollHeight - stage.clientHeight) / 2);
        stage.focus();
      });
    } else {
      stage.scrollLeft = 0; stage.scrollTop = 0;
    }
  }

  function show(i) {
    idx = (i + triggers.length) % triggers.length;
    var t = triggers[idx];
    setZoom(false);
    img.src = t.getAttribute('data-full');
    img.alt = t.getAttribute('data-alt') || '';
    count.textContent = (idx + 1) + ' of ' + triggers.length;
    live.textContent = '';
    setTimeout(function () { live.textContent = 'Image ' + (idx + 1) + ' of ' + triggers.length; }, 50);
  }

  function open(i, trigger) {
    lastFocus = trigger || document.activeElement;
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    inertOthers(true);
    show(i);
    closeBtn.focus();
  }
  function shut() {
    lb.hidden = true;
    document.documentElement.style.overflow = '';
    inertOthers(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  triggers.forEach(function (t, i) {
    t.addEventListener('click', function () { open(i, t); });
  });
  closeBtn.addEventListener('click', shut);
  prevBtn.addEventListener('click', function () { show(idx - 1); });
  nextBtn.addEventListener('click', function () { show(idx + 1); });
  zoomBtn.addEventListener('click', function () { setZoom(!lb.classList.contains('zoomed')); });
  img.addEventListener('click', function () { setZoom(!lb.classList.contains('zoomed')); });
  stage.addEventListener('click', function (e) { if (e.target === stage && !lb.classList.contains('zoomed')) shut(); });

  document.addEventListener('keydown', function (e) {
    if (lb.hidden) return;
    var zoomed = lb.classList.contains('zoomed');
    if (e.key === 'Escape') { e.preventDefault(); shut(); return; }
    if (!zoomed && e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); return; }
    if (!zoomed && e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); return; }
    if (e.key === '+' || e.key === '=') { e.preventDefault(); setZoom(true); return; }
    if (e.key === '-' || e.key === '_') { e.preventDefault(); setZoom(false); return; }
    if (e.key === 'Tab') {
      var items = Array.prototype.slice.call(lb.querySelectorAll(FOCUSABLE)).filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || !lb.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !lb.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  });
})();
